
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/candidate/messages",
      function () {
        return require("private-next-pages/candidate/messages/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/candidate/messages"])
      });
    }
  